// hooks/useInView.js
import { useEffect, useRef, useState } from "react";

export default function useInView(name = "section", options = {}) {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        console.log(`${name} is now in viewport — component loaded`)
        observer.disconnect(); // stop observing once visible
      }
    }, { rootMargin: "200px", ...options }); // 200px pre-load buffer

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return [ref, isInView];
}